import axios  from "axios";
export default {
  state: {
    emailForgot: "",
    codeForgot:'',
    isSendCode:false,
    codeNumber:''
  },
  getters: {
    emailForgot_(state) {
      return state.emailForgot;
    },
    codeForgot_(state){
      return state.codeForgot
    },
    getCode_(state){
      return state.codeNumber
    }
  },
  actions: {
    async _setEmail({commit}, val){
      await axios.post('user/forgotPassword/seller', {
        email:val
      })
      .then((res)=>{
        if(res.data.status.code != 200){
          alert('sadsa')
        } else {
          commit('setEmail', val)
        }
      })
    },
    async _setCode({commit}, val){
      await axios.put('user/checkForgotPassword/seller', {
        code:val.code,
        email:val.email
      })
      .then((res)=>{
        commit('setCode', res.data.status)
        commit('setCodeNumber', val.code)
      })
    }
  },
  mutations: {
    setEmail(state, data) {
      state.emailForgot = data;
    },
    setCode(state,data) {
      state.codeForgot = data
      state.isSendCode = true
    },
    setCodeNumber(state,code){
      state.codeNumber = code
    }
  },
};
